import { useI18n } from "@core/i18n/i18n";
import { PendingPatient } from "@domain/patient/patient";
import { colors } from "@ui/style/colors";
import React, { useMemo } from "react";

interface ExpirationRemainingDaysProps {
	patient: PendingPatient;
}

const RED_THRESHOLD = 5;
const ORANGE_THRESHOLD = 10;

export const ExpirationRemainingDays = ({ patient }: ExpirationRemainingDaysProps): JSX.Element => {
	const { format } = useI18n();

	const labelColor = useMemo(() => {
		if (patient.expirationDays < RED_THRESHOLD) {
			return colors.rejection;
		}
		if (patient.expirationDays < ORANGE_THRESHOLD) {
			return colors.orange;
		}
		return colors.black;
	}, [patient.expirationDays]);

	return (
		<span style={{ color: labelColor }}>
			{format("home.pendingPatientsListing.expiresInColumn.item", { remainingDays: patient.expirationDays })}
		</span>
	);
};
